import lightModeBulkOps from '../assets/bulkopsM3Changeboarding.gif';

import lightModeColors from '../assets/coloursM3changeboarding.gif';

import lightModeSubtasks from '../assets/subtasksM3changeboarding.gif';

import lightModeFilter from '../assets/filteretcM3changeboarding.gif';

import { messages } from './messages';

import { type TourContent } from './types';

export const MODAL_WIDTH = 968;

export const MODAL_HEIGHT = 619;

export const READ_ABOUT_URL =
	'https://community.atlassian.com/forums/Jira-articles/Unified-More-Powerful-Timeline-for-Jira-Software-Projects/ba-p/3219209';

export const tourContent: TourContent[] = [
	{
		content: messages.descriptionContentBulkOperations,
		title: messages.headingContentBulkOperations,
		illustration: lightModeBulkOps,
	},
	{
		content: messages.descriptionContentCustomizeBar,
		title: messages.headingContentCustomizeBar,
		illustration: lightModeColors,
	},
	{
		content: messages.descriptionContentSeeSubtasks,
		title: messages.headingContentSeeSubtasks,
		illustration: lightModeSubtasks,
	},
	{
		content: messages.descriptionContentFindWork,
		title: messages.headingContentFindWork,
		illustration: lightModeFilter,
	},
];
